
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-examples",
      function () {
        return require("private-next-pages/ad-examples/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-examples"])
      });
    }
  